import { usePortalsStore } from "@/Store/portals/portals.selector"
import { useCallback } from "react"

const useCloseOrdersUpdater = () => {
    const {setOrdersUpdater} = usePortalsStore().actions
    return useCallback(() => setOrdersUpdater({isShowOrdersUpdater: false, ordersToUpdate: undefined}),[])
}
export default useCloseOrdersUpdater